module.exports = __webpack_public_path__ + "img/soccerboard20.78de8f0c.jpg";